import React from "react";
import { headerHolder } from "./Header.module.scss";
import { motion } from "framer-motion";
import { Link } from "gatsby";

const times = (length, fn) => Array.from({ length }, (_, i) => fn(i));

const headerVariants = {
  initial: {
    opacity: 0,
    y: "22vh",
    scale: 0.68,
  },
  homeHeader: {
    opacity: 1,
    y: "19vh",
    scale: 0.7,
    transition: {
      duration: 0.7,
      type: "tween",
      staggerChildren: 0.04,
      delayChildren: 0.1,
    },
  },
  smallHeader: {
    opacity: 1,
    y: "-5vh",
    scale: 0.3,
    transition: {
      duration: 0.5,
      type: "tween",
      staggerChildren: 0.04,
    },
  },
  whatWeAreHeader: {
    opacity: 1,
    y: "13vh",
    scale: 0.65,
    transition: {
      duration: 0.5,
      type: "tween",
      staggerChildren: 0.04,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5,
      type: "tween",
      ease: "anticipate",
    },
  },
};

const letterVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  homeHeader: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
  smallHeader: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
  whatWeAreHeader: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
  },
};

const dotVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  homeHeader: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
  smallHeader: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
      ease: "easeOut",
    },
  },
  whatWeAreHeader: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
  },
};

export default function Header({ location }) {
  const isHome = location.pathname === "/";
  const isWhoWeAre = location.pathname.includes("who-we-are");
  const isWhatWeAre = location.pathname.includes("what-we-are");
  const isPress = location.pathname.includes("press");
  const isContact = location.pathname.includes("contact");
  let headerVariant = "homeHeader";
  if (isWhoWeAre || isPress || isContact) {
    headerVariant = "smallHeader";
  }
  if (isWhatWeAre) {
    headerVariant = "whatWeAreHeader";
  }

  const theLetters = "The".split("");
  const creativesLetters = "Creatives".split("");

  return (
    <motion.header className={headerHolder}>
      <motion.div
        className="headerInner"
        variants={headerVariants}
        initial="initial"
        animate={headerVariant}
        exit="exit"
      >
        <Link to="/" title="Home">
          <h1>
            <span className="the">
              {theLetters.map((letter, index) => (
                <motion.span
                  key={`the-${index}`}
                  variants={letterVariants}
                  style={{ display: "inline-block" }}
                >
                  {letter}
                </motion.span>
              ))}
            </span>{" "}
            <span className="creatives">
              {creativesLetters.map((letter, index) => (
                <motion.span
                  key={`creatives-${index}`}
                  variants={letterVariants}
                  style={{ display: "inline-block" }}
                >
                  {letter}
                </motion.span>
              ))}
            </span>
          </h1>
          <div className="dots">
            {times(9, (i) => (
              <motion.div className="dot" key={i} variants={dotVariants} />
            ))}
          </div>
        </Link>
      </motion.div>
    </motion.header>
  );
}
